export const initialErrorValues = {
  initiated: false,
  student: {},
  parent: {},
  school: {},
  extra: {}
}